import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Chip from '@material-ui/core/Chip';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Button from '@material-ui/core/Button';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import SaveIcon from '@material-ui/icons/Save';
import Grid from '@material-ui/core/Grid';
import Alert from '@material-ui/lab/Alert';
import Collapse from '@material-ui/core/Collapse';
import CircularProgress from '@material-ui/core/CircularProgress';
import Modal from '@material-ui/core/Modal';
import moment from 'moment';
import 'moment/locale/pt-br';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { XMEI_PRIMARY_COLOR } from '../../consts/common';
import environment from '../../environment';
import { instanceAxios } from '../../InstanceAxios';
import HeadTable from '../../components/HeadTable';
import TableSortLabel from "@material-ui/core/TableSortLabel";
import FilterIcon from "@material-ui/icons/FilterList";

const useStyles = (theme) => ({
  root: {
    overflow: 'hidden',
    width: '95%',
  },
  button: {
    margin: theme.spacing(1),
  },
  selectTipo: {
    width: 200,
  },
  paper: {
    position: 'absolute',
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    top: `50%`,
    left: `50%`,
    transform: `translate(-50%, -50%)`,
    width: '80%',
    height: '80%',
    overflow: 'auto',
    width: '80%',
    height: '80%',
    overflow: 'auto',
  },
  loading: {
    marginLeft: '50%',
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
});

class ServicoComponent extends Component {
  constructor() {
    super();
    this.axios = instanceAxios(localStorage.getItem('toobiauth'));
    moment.locale('pt-br');
  }

  state = {
    servicos: [],
    originalServicos: [],
    filterText: '', // Filter text
    isModalOpen: false, // Modal open state
    modalPosition: { top: 0, left: 0 },  // Position of the modal
    modalColumnId: null,
    orderBy: '', // Coluna pela qual estamos ordenando
    columns: [
      { id: 'nome', label: 'Nome', minWidth: 140,filterable: true },
      { id: 'valor', label: 'Valor', minWidth: 140,filterable: true },
      { id: `tipo_servico`, label: 'Tipo', minWidth: 60,filterable: true },
      { id: 'recorrente', label: 'Recorrente', minWidth: 140, filterable: true },
      { id: 'ativo', label: 'Ativo', minWidth: 70, filterable: true },
      { id: 'editar', label: '', minWidth: 140, filterable: false },
    ],
    servico: {},
    p1: [],
    p2: [],
    d1: [],
    d2: [],
    checked: [],
    checkedDocumentos: [],
    isEdit: false,
    openErro: false,
    openWarning: false,
    openSucess: false,
    openValid: false,
    mensagemValidacao: '',
    openModal: false,
    openWarningPagamento: false,
    openWarningDocumentos: false,
    openWarningDesvincularPagamento: false,
    openWarningDesvincularDocumento: false,
    ready: false,
    abaModal: 'PAGAMENTOS',
    order: 'asc',
    idOrder: '',
  };

  UNSAFE_componentWillMount() {
    this.axios.get(`${environment}/formaspagamento`).then((res) => {
      const pagamentos = res.data;
      const p1 = [];
      const p2 = [];
      pagamentos.forEach((element, index) => {
        if (index % 2 === 0) p1.push(element);
        else p2.push(element);
      });

      this.setState({ p1 });
      this.setState({ p2 });
    });

    this.axios.get(`${environment}/documentonecessario`).then((res) => {
      const pagamentos = res.data;
      const d1 = [];
      const d2 = [];
      pagamentos.forEach((element, index) => {
        if (index % 2 === 0) d1.push(element);
        else d2.push(element);
      });

      this.setState({ d1 });
      this.setState({ d2 });
    });

    this.atualizar('', '');
  }

  async atualizar(io, o) {
    this.setState({ ready: false });
    await this.axios
      .get(`${environment}/servicos?campoOrdenacao=${io}&ordem=${o}`)
      .then((res) => {
        const servicos = res.data;
        this.setState({ servicos });
        this.setState({ originalServicos: servicos });
        this.setState({ ready: true });
      })
      .catch((err) => {
        this.setState({ openError: true });
        this.setState({ ready: true });
      });
  }

  clickAlert = () => {
    this.setState({ openError: false });
    this.setState({ openSucess: false });
    this.setState({ openWarning: false });
    this.setState({ openValid: false });
    this.setState({ openWarningPagamento: false });
    this.setState({ openWarningDocumentos: false });
    this.setState({ openWarningDesvincularPagamento: false });
    this.setState({ openWarningDesvincularDocumento: false });
  };

  handleAtivarDesativar = async () => {
    this.setState({ openWarning: true });
    await this.axios
      .get(`${environment}/servicos/ativar/${this.state.cliente.id}`)
      .then(async (resp) => {
        this.atualizar(this.state.idOrder, this.state.order);
        this.setState({ openWarning: false });
        this.setState({ openModal: false });
        this.setState({ openSucess: true });
      })
      .catch((err) => {
        this.setState({ openWarning: false });
        this.setState({ openModal: false });
        this.setState({ openError: true });
      });
  };

  setIdOrder = (idOrder) => {
    // Checando se Não é a coluna Editar
    if (idOrder === 'editar') return;

    let order;
    // Checando se é o mesmo atual
    if (idOrder === this.state.idOrder) {
      order = this.state.order === 'asc' ? 'desc' : 'asc';
      this.setState({ order });
    } else {
      order = 'asc';
      this.setState({ order, idOrder });
    }
    this.atualizar(idOrder, order);
  };

  handleOpen = (servico, isEdit) => {
    this.setState({ isEdit });
    const { checked } = this.state;
    const { checkedDocumentos } = this.state;
    this.clickAlert();
    if (isEdit) {
      servico.servico_forma_pagamento.map((sfp) => {
        checked.push(sfp.forma_de_pagamento.id);
      });
      servico.documentos_necessario_servicos.map((dns) => {
        checkedDocumentos.push(dns.id_documento_necessario);
      });
    }
    this.setState({ servico });
    this.setState({ openModal: true });
    this.setState({ checked });
    this.setState({ checkedDocumentos });
  };

  handleClose = () => {
    this.clickAlert();
    this.atualizar(this.state.idOrder, this.state.order);
    this.setState({ cliente: {} });
    this.setState({ checked: [] });
    this.setState({ checkedDocumentos: [] });
    this.setState({ openModal: false });
  };

  validar = () => {
    let valid = true;
    let msg = 'Preencha os seguintes campos:';
    if (!this.state.servico.nome || this.state.servico.nome === '') {
      valid = false;
      msg += 'Nome,';
    }
    if (
      !this.state.servico.tipo_servico ||
      this.state.servico.tipo_servico === ''
    ) {
      valid = false;
      msg += 'Tipo Serviço,';
    }
    if (this.state.servico.ativo === undefined) {
      valid = false;
      msg += 'Ativo,';
    }
    if (!this.state.servico.descricao || this.state.servico.descricao === '') {
      valid = false;
      msg += 'Descrição,';
    }
    if (!this.state.servico.valor || this.state.servico.valor === NaN) {
      valid = false;
      msg += 'Valor,';
    }
    if (this.state.servico.recorrente === undefined) {
      valid = false;
      msg += 'Recorrência,';
    }
    this.setState({ mensagemValidacao: msg });
    return valid;
  };

  handleSalvar = async () => {
    if (!this.validar()) {
      this.setState({ openValid: true });
    } else if (this.state.checked.length === 0) {
      this.setState({ openWarningPagamento: true });
      this.setState({ abaModal: 'PAGAMENTOS' });
    } else if (this.state.checkedDocumentos.length === 0) {
      this.setState({ openWarningDocumentos: true });
      this.setState({ abaModal: 'DOCUMENTOS' });
    } else {
      this.setState({ openWarning: true });
      await this.axios
        .post(`${environment}/servicos`, this.state.servico)
        .then(async (data) => {
          // Checando Se precisa adicionar formas de pagamento
          if (!this.state.isEdit) {
            for (const c of this.state.checked) {
              await this.axios
                .post(`${environment}/vincularpagamento`, {
                  id_servico: data.data.id,
                  id_formadepagamento: c,
                })
                .then((data) => console.log('Adicionando Pagamento!'))
                .catch((err) => this.setState({ openErro: true }));
            }
            for (const c of this.state.checkedDocumentos) {
              await this.axios
                .post(`${environment}/vincularDocumentoNecessario`, {
                  id_servico: data.data.id,
                  id_documento_necessario: c,
                })
                .then((data) => console.log('Adicionando Documento!'))
                .catch((err) => this.setState({ openErro: true }));
            }
          }
          this.atualizar(this.state.idOrder, this.state.order);
          this.setState({ servico: {} });
          this.setState({ openWarning: false });
          this.setState({ openSucess: true });
          this.setState({ openModal: false });
        })
        .catch((err) => {
          this.setState({ servico: {} });
          this.setState({ openError: true });
          this.setState({ openModal: false });
        });
    }
  };

  handleVincular = async (idFormaPagamento) => {
    const lista = this.state.checked;
    // Checando se é Edição para vincular pagamento ou apenas guardar para salvar
    if (this.state.isEdit) {
      if (lista.includes(idFormaPagamento)) {
        if (lista.length === 1) {
          this.setState({ openWarningDesvincularPagamento: true });
          return;
        }
        await this.axios
          .post(`${environment}/desvincularpagamento`, {
            id_servico: this.state.servico.id,
            id_formadepagamento: idFormaPagamento,
          })
          .then((data) => {
            lista.splice(lista.indexOf(idFormaPagamento), 1);
          })
          .catch((err) => {
            this.setState({ openErro: true });
          });
      } else {
        await this.axios
          .post(`${environment}/vincularpagamento`, {
            id_servico: this.state.servico.id,
            id_formadepagamento: idFormaPagamento,
          })
          .then((data) => {
            lista.push(idFormaPagamento);
          })
          .catch((err) => {
            this.setState({ openErro: true });
          });
      }
      this.setState({ checked: lista });
    } else {
      if (lista.includes(idFormaPagamento))
        lista.splice(lista.indexOf(idFormaPagamento), 1);
      else lista.push(idFormaPagamento);
      this.setState({ checked: lista });
    }
  };

  handleVincularDocumento = async (idDocumentoNecessario) => {
    const lista = this.state.checkedDocumentos;
    // Checando se é Edição para vincular pagamento ou apenas guardar para salvar
    if (this.state.isEdit) {
      if (lista.includes(idDocumentoNecessario)) {
        if (lista.length === 1) {
          this.setState({ openWarningDesvincularDocumento: true });
          return;
        }
        await this.axios
          .post(`${environment}/desvincularDocumentoNecessario`, {
            id_servico: this.state.servico.id,
            id_documento_necessario: idDocumentoNecessario,
          })
          .then((data) => {
            lista.splice(lista.indexOf(idDocumentoNecessario), 1);
          })
          .catch((err) => {
            this.setState({ openErro: true });
          });
      } else {
        await this.axios
          .post(`${environment}/vincularDocumentoNecessario`, {
            id_servico: this.state.servico.id,
            id_documento_necessario: idDocumentoNecessario,
          })
          .then((data) => {
            lista.push(idDocumentoNecessario);
          })
          .catch((err) => {
            this.setState({ openErro: true });
          });
      }
      this.setState({ checkedDocumentos: lista });
    } else {
      if (lista.includes(idDocumentoNecessario))
        lista.splice(lista.indexOf(idDocumentoNecessario), 1);
      else lista.push(idDocumentoNecessario);
      this.setState({ checkedDocumentos: lista });
    }
  };

  openModal = (event, columnid) => {
    this.setState({ filterText: '' });
    const rect = event.target.getBoundingClientRect();
    this.setState({ isModalOpen: true, modalPosition: { top: rect.bottom, left: rect.left }, modalColumnId: columnid });
  };

  handleFilterTextChange = (event) => {
    this.setState({ filterText: event.target.value });
  };

  // Function to filter the table data
  filterTable = () => {
    this.setState({ isModalOpen: false});
    const { servicos, filterText, modalColumnId } = this.state;
    const filteredDas = servicos.filter(item => {
      const value = this.getValueColumnId(modalColumnId,item);
      return value && value.toString().toLowerCase().includes(filterText.toLowerCase());
    });
    // Update the table data with filtered data
    this.setState({ servicos: filteredDas });
  };

  getValueColumnId(columnId,rowData) {
    columnId = columnId.replace(/"/g, '');
    console.log(columnId);
    const parts = columnId.split('.');
    console.log(rowData);
    console.log(parts);
    let result = null;
    for (let part of parts) {
      if (result === null) {
        // If result is null, assign the global object to result
        result = rowData[part];
      } else {
        // If result is not null, access the property
        result = result[part];
      }
    }
    console.log(result)
    return result;
  }
  clearFilter = () => {
    this.setState({ isModalOpen: false});
    this.setState({ filterText: '', servicos: this.state.originalServicos });
  };

  closeModal = () => {
    this.setState({ isModalOpen: false });
  };

  handleRequestSort = (property) => {
    const orderBy = property;
    let order = 'desc';

    if (this.state.orderBy === property && this.state.order === 'desc') {
      order = 'asc';
    }

    this.setState({ order, orderBy });



  };

  sortTable = (property) => {
    const { servicos, order } = this.state;
    console.log(property);
    const isAsc = order === 'asc';
    servicos.sort((a, b) => {
      let aValue = this.getValueColumnId(property,a);
      let bValue = this.getValueColumnId(property,b);
      // If the property is a string, convert to lowercase for case-insensitive sorting
      if (typeof aValue === 'string') {
        aValue = aValue.toLowerCase();
        bValue = bValue.toLowerCase();
      }
      if (aValue < bValue) {
        return isAsc ? -1 : 1;
      }
      if (aValue > bValue) {
        return isAsc ? 1 : -1;
      }
      return 0;
    });
    this.setState({ servicos });
  };

  render() {
    const { classes } = this.props;

    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          paddingTop: 20,
        }}
      >
        <Modal open={this.state.isModalOpen} onClose={this.closeModal} style={{ top: this.state.modalPosition.top, left: this.state.modalPosition.left }}>
          <div style={{ backgroundColor: 'white', padding: '20px', borderRadius: '5px', width: '300px' }}>
            <TextField
              label="Filtrar"
              variant="outlined"
              value={this.state.filterText}
              onChange={this.handleFilterTextChange}
              fullWidth
            />
            <Button variant="contained" color="primary" onClick={this.filterTable} style={{ marginTop: '10px' }}>
              Filtrar
            </Button>
            <Button  variant="contained" color="secondary" onClick={this.clearFilter} style={{ marginTop: '10px',marginLeft: '5px',width:70 }}>
              Limpar
            </Button>
          </div>
        </Modal>
        <Collapse in={this.state.openErro}>
          <Alert severity="error" onClick={this.clickAlert}>
            Erro realizar ação,tente mais tarde!
          </Alert>
        </Collapse>
        <Collapse in={this.state.openSucess}>
          <Alert severity="success" onClick={this.clickAlert}>
            Ação realizada Com Sucesso!
          </Alert>
        </Collapse>
        <Paper className={classes.root}>
          <Collapse in={this.state.ready}>
            <Grid
              container
              style={{ paddingLeft: 10, paddingRight: 10, paddingTop: '1%' }}
            >
              <Grid item xs={6}>
                <h1>Serviços</h1>
              </Grid>
              <Grid item xs={6}>
                <div align="right">
                  <Button
                    variant="contained"
                    startIcon={<AddCircleIcon />}
                    style={{
                      backgroundColor: XMEI_PRIMARY_COLOR,
                      color: '#FFF',
                    }}
                    size="large"
                    onClick={() => this.handleOpen({}, false)}
                  >
                    Novo
                  </Button>
                </div>
              </Grid>
            </Grid>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {this.state.columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{minWidth: column.minWidth}}
                      sortDirection={this.state.orderBy === column.id ? this.state.order : false}
                    >
                      <div style={{display: 'flex', alignItems: 'center'}}>
                        <TableSortLabel
                          active={this.state.orderBy === column.id}
                          direction={this.state.orderBy === column.id ? this.state.order : 'asc'}
                          onClick={() => {
                            this.handleRequestSort(column.id);
                            setTimeout(() => {
                              this.sortTable(column.id);
                            }, 200);
                          }}
                        >
                          {column.label}
                        </TableSortLabel>

                        {column.filterable && (
                          <IconButton style={{marginLeft:-5}}   onClick={event => this.openModal(event,column.id)} aria-label="filtra">
                            <FilterIcon style={{width:16,height:16  }} />
                          </IconButton>
                        )}
                      </div>

                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {this.state.servicos.map((s) => {
                  return (
                    <TableRow key={s.id}>
                      <TableCell component="th" scope="row">
                        {s.nome}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {`R$${s.valor}`}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        <Collapse in={s.tipo_servico === 1}>Padrão</Collapse>
                        <Collapse in={s.tipo_servico === 2}>
                          Legalização
                        </Collapse>
                        <Collapse in={s.tipo_servico === 3}>
                          Não Direto
                        </Collapse>
                      </TableCell>
                      <TableCell component="th" scope="row">
                        <Collapse in={s.recorrente}>
                          <Chip label="Sim" color="primary" />
                        </Collapse>
                        <Collapse in={!s.recorrente}>
                          <Chip label="Não" color="secondary" />
                        </Collapse>
                      </TableCell>
                      <TableCell component="th" scope="row">
                        <Collapse in={s.ativo}>
                          <Chip label="Sim" color="primary" />
                        </Collapse>
                        <Collapse in={!s.ativo}>
                          <Chip label="Não" color="secondary" />
                        </Collapse>
                      </TableCell>
                      <TableCell component="th" scope="row">
                        <IconButton
                          onClick={() => this.handleOpen(s, true)}
                          style={{
                            color: XMEI_PRIMARY_COLOR,
                          }}
                          aria-label="Editar Serviço"
                        >
                          <EditIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </Collapse>
          <Collapse in={this.state.ready === false}>
            <CircularProgress className={classes.loading} />
          </Collapse>
        </Paper>

        <Modal
          className={classes.modal}
          open={this.state.openModal}
          onClose={this.handleClose}
        >
          <Grid container spacing={1} className={classes.paper}>
            <Grid item xs={12}>
              <h2>Dados do Serviço</h2>
            </Grid>
            <Collapse in={this.state.openWarningPagamento}>
              <Alert severity="Warning" onClick={this.clickAlert}>
                Selecione uma forma de pagamento!
              </Alert>
            </Collapse>
            <Collapse in={this.state.openWarningDocumentos}>
              <Alert severity="Warning" onClick={this.clickAlert}>
                Selecione um documento necessário!
              </Alert>
            </Collapse>
            <Collapse in={this.state.openWarningDesvincularPagamento}>
              <Alert severity="Warning" onClick={this.clickAlert}>
                Não é permitido Deixar um serviço sem nenhuma forma de
                pagamento!
              </Alert>
            </Collapse>
            <Collapse in={this.state.openWarningDesvincularDocumento}>
              <Alert severity="Warning" onClick={this.clickAlert}>
                Não é permitido Deixar um serviço sem nenhuma documento
                necessário!
              </Alert>
            </Collapse>
            <Collapse in={this.state.openWarning}>
              <Alert severity="Warning" onClick={this.clickAlert}>
                Aguarde!
              </Alert>
            </Collapse>
            <Grid item xs={12}>
              <Collapse in={this.state.openValid}>
                <Alert
                  severity="warning"
                  onClick={this.clickAlert}
                  style={{ textAlign: 'center' }}
                >
                  {this.state.mensagemValidacao}
                </Alert>
              </Collapse>
            </Grid>
            <Grid item xs={12}>
              <Grid container spacing={3}>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    id="nome"
                    label="Nome"
                    variant="outlined"
                    value={this.state.servico.nome}
                    onChange={(event) => {
                      const obj = this.state.servico;
                      obj.nome = event.target.value;
                      this.setState({ servico: obj });
                    }}
                  />
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    fullWidth
                    id="tipoServico"
                    variant="outlined"
                    select
                    label="Tipo Serviço"
                    value={this.state.servico.tipo_servico}
                    onChange={(event) => {
                      const obj = this.state.servico;
                      obj.tipo_servico = event.target.value;
                      this.setState({ servico: obj });
                    }}
                  >
                    <MenuItem key="padrao" value="1">
                      Padrão
                    </MenuItem>
                    <MenuItem key="legatizacao" value="2">
                      Legalização
                    </MenuItem>
                    <MenuItem key="naoDireto" value="3">
                      Não Direto
                    </MenuItem>
                  </TextField>
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    fullWidth
                    id="ativo"
                    variant="outlined"
                    select
                    label="Ativo"
                    value={this.state.servico.ativo}
                    onChange={(event) => {
                      const obj = this.state.servico;
                      obj.ativo = event.target.value;
                      this.setState({ servico: obj });
                    }}
                  >
                    <MenuItem key="padrao" value="true">
                      Sim
                    </MenuItem>
                    <MenuItem key="legatizacao" value="false">
                      Não
                    </MenuItem>
                  </TextField>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    id="descricao"
                    label="Descrição"
                    variant="outlined"
                    multiline
                    rowsMax="5"
                    value={this.state.servico.descricao}
                    onChange={(event) => {
                      const obj = this.state.servico;
                      obj.descricao = event.target.value;
                      this.setState({ servico: obj });
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    id="valor"
                    label="Valor"
                    type="number"
                    variant="outlined"
                    value={this.state.servico.valor}
                    onChange={(event) => {
                      const obj = this.state.servico;
                      obj.valor = event.target.value;
                      this.setState({ servico: obj });
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    id="detalhamentoValor"
                    label="Detalhamento Valor"
                    variant="outlined"
                    value={this.state.servico.detalhamento_valor}
                    onChange={(event) => {
                      const obj = this.state.servico;
                      obj.detalhamento_valor = event.target.value;
                      this.setState({ servico: obj });
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    id="recorrente"
                    variant="outlined"
                    select
                    label="Recorrente"
                    value={this.state.servico.recorrente}
                    onChange={(event) => {
                      const obj = this.state.servico;
                      obj.recorrente = event.target.value;
                      this.setState({ servico: obj });
                    }}
                  >
                    <MenuItem key="sim" value="true">
                      Sim
                    </MenuItem>
                    <MenuItem key="nao" value="false">
                      Não
                    </MenuItem>
                  </TextField>
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    fullWidth
                    id="necessario_assinatura"
                    variant="outlined"
                    select
                    label="Nec.Assinatura"
                    value={this.state.servico.necessario_assinatura}
                    onChange={(event) => {
                      const obj = this.state.servico;
                      obj.necessario_assinatura = event.target.value;
                      this.setState({ servico: obj });
                    }}
                  >
                    <MenuItem key="sim" value="true">
                      Sim
                    </MenuItem>
                    <MenuItem key="nao" value="false">
                      Não
                    </MenuItem>
                  </TextField>
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    fullWidth
                    id="recorrente"
                    variant="outlined"
                    select
                    label="Recorrente"
                    value={this.state.servico.recorrente}
                    onChange={(event) => {
                      const obj = this.state.servico;
                      obj.recorrente = event.target.value;
                      this.setState({ servico: obj });
                    }}
                  >
                    <MenuItem key="sim" value="true">
                      Sim
                    </MenuItem>
                    <MenuItem key="nao" value="false">
                      Não
                    </MenuItem>
                  </TextField>
                </Grid>
                <Grid item xs={12}>
                  <div align="center">
                    <ButtonGroup
                      size="large"
                      color="primary"
                      aria-label="large outlined primary button group"
                    >
                      <Button
                        variant={
                          this.state.abaModal === 'PAGAMENTOS'
                            ? 'contained'
                            : 'outlined'
                        }
                        onClick={() =>
                          this.setState({ abaModal: 'PAGAMENTOS' })
                        }
                      >
                        Formas de Pagamento
                      </Button>
                      <Button
                        onClick={() =>
                          this.setState({ abaModal: 'DOCUMENTOS' })
                        }
                        variant={
                          this.state.abaModal === 'DOCUMENTOS'
                            ? 'contained'
                            : 'outlined'
                        }
                      >
                        Documentos Necessários
                      </Button>
                    </ButtonGroup>
                  </div>
                  <Collapse in={this.state.abaModal === 'PAGAMENTOS'}>
                    <FormControl
                      component="fieldset"
                      className={classes.formControl}
                    >
                      <FormGroup>
                        {this.state.p1.map((p) => (
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={this.state.checked.includes(p.id)}
                                onChange={() => this.handleVincular(p.id)}
                              />
                            }
                            label={`${p.descricao} - ${p.parcelas} parcelas`}
                          />
                        ))}
                      </FormGroup>
                    </FormControl>
                    <FormControl
                      component="fieldset"
                      className={classes.formControl}
                    >
                      <FormGroup>
                        {this.state.p2.map((p) => (
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={this.state.checked.includes(p.id)}
                                onChange={() => this.handleVincular(p.id)}
                              />
                            }
                            label={`${p.descricao} - ${p.parcelas} parcelas`}
                          />
                        ))}
                      </FormGroup>
                    </FormControl>
                  </Collapse>
                  <Collapse in={this.state.abaModal === 'DOCUMENTOS'}>
                    <Grid container>
                      <Grid item xs={12} sm={12} md={6} lg={6}>
                        <FormControl
                          component="fieldset"
                          className={classes.formControl}
                        >
                          <FormGroup>
                            {this.state.d1.map((d) => (
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={this.state.checkedDocumentos.includes(
                                      d.id
                                    )}
                                    onChange={() =>
                                      this.handleVincularDocumento(d.id)
                                    }
                                  />
                                }
                                label={d.nome}
                              />
                            ))}
                          </FormGroup>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={12} md={6} lg={6}>
                        <FormControl
                          component="fieldset"
                          className={classes.formControl}
                        >
                          <FormGroup>
                            {this.state.d2.map((d) => (
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={this.state.checkedDocumentos.includes(
                                      d.id
                                    )}
                                    onChange={() =>
                                      this.handleVincularDocumento(d.id)
                                    }
                                  />
                                }
                                label={d.nome}
                              />
                            ))}
                          </FormGroup>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </Collapse>
                </Grid>
                <Grid item xs={12}>
                  <div align="right">
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={this.handleSalvar}
                      startIcon={<SaveIcon />}
                    >
                      Salvar
                    </Button>
                  </div>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Modal>
      </div>
    );
  }
}

export default withStyles(useStyles)(ServicoComponent);
